<div class="fab-container">
  <button mat-fab class="call-to-action fab-toggler" (click)="onToggleFab()" [matTooltip]="tooltip"
    [style.background]="backgroundColor" [style.color]="foregroundColor" matTooltipPosition="before">
    <mat-icon [innerHtml]="icon" [@fabToggler]="{value: fabTogglerState}"></mat-icon>
  </button>
  <div [@speedDialStagger]="buttons.length">
    <button *ngFor="let btn of buttons" [matTooltip]="btn.tooltip" matTooltipPosition="before"
      [style.background]="speedDialBackgroundColor" [style.color]="speedDialForegroundColor" mat-mini-fab
      (click)="btn.action();" class="fab-secondary" color="secondary">
      <i class="material-icons">{{btn.icon}}</i>
    </button>
  </div>
</div>
